import classnames from 'classnames';

import { isDDEnv } from '@/utils/helper';

import { CtfCtaStyle } from '@/utils/constants';
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

const BUTTON_BASE_CLASS = {
  Primary: '',
  Secondary:
    'aaco-underline',
  Tertiary: '',
};

export const BUTTON_VARIANTS = Object.keys(BUTTON_BASE_CLASS);

export const getButtonClassWH = ({ type, invert, style }) => {
  return classnames(
    BUTTON_BASE_CLASS[type] ?? BUTTON_BASE_CLASS.Primary,
    TEXT_BASE_CLASS.button,
    {
      'text-white': invert,
      'decoration-eucalyptus': invert && type === CtfCtaStyle.SECONDARY,
      'hover:border-b hover:border-b-white': invert,
    },
    style
  );
};

export const getButtonClass = ({ type, invert, style }) => {
  if (isDDEnv()) return style;
  return getButtonClassWH({ type, invert, style });
};
